<ul>
  @for (breadcrumb of breadcrumbs; track breadcrumb) {
    <li
      [ngClass]="{ parent: breadcrumb.url }"
      >
      @if (
        breadcrumb.url &&
        (!breadcrumb.navigationOption ||
        breadcrumb.navigationOption === NavigationOption_ROUTERLINK)
        ) {
        <a
          [routerLink]="breadcrumb.url"
          >
          <span class="left-arrow">&lsaquo;</span>
          {{ breadcrumb.text | translate }}
        </a>
      }
      @if (
        breadcrumb.url &&
        breadcrumb.navigationOption &&
        breadcrumb.navigationOption === NavigationOption_HREF
        ) {
        <a
          [href]="breadcrumb.url"
          >
          <span class="left-arrow">&lsaquo;</span>
          {{ breadcrumb.text | translate }}
        </a>
      }
      @if (!breadcrumb.url) {
        <span>
          {{ breadcrumb.text | translate }}
        </span>
      }
      <span class="right-arrow">&rsaquo;</span>
    </li>
  }
</ul>
